import React, { Component } from "react";
import { connect } from "react-redux";
import { req_add_eps_deeds_customize } from "../../api";
import storageUtils from "../../utils/storageUtils";
import { Card, Input, message } from "antd";
const { TextArea } = Input;
class AchievementDeedsTeacherAddModal extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    item: {
      BloggerCode: "",
      MainCategory: "achievement",
      SubCategory: "other",
      EventTitle: "",
      EventDescription: "",
      ShowStatus: "ON",
    },
  };

  UNSAFE_componentWillMount() {}

  componentDidMount() {
    this.init();
  }

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_add_item = async (item) => {
    const result = await req_add_eps_deeds_customize(
      item,
      storageUtils.getUser().token
    );
    if (result.status === "success") {
      message.success(result.message);
    } else {
      message.error(result.message);
    }
  };
  
  // 操作互動處理 //////////////////////////////////////////////

  init = () => {};

  handleChange(event) {
    const { item } = this.state;
    //console.log(event)
    Object.keys(item).forEach((propertyName) => {
      if (event.target.id === propertyName && event.target.value !== null) {
        item[propertyName] = event.target.value.trim();
      }
    });
    this.setState({ item });
  }

  handleSubmit(event) {
    event.preventDefault();
    const row = this.state.item;
    const errors = [];

    if (row.SubCategory === "other") {
      errors.push("分類未選擇");
    }

    if (row.EventTitle.trim() === "") {
      errors.push("內容未填寫");
    }

    if (errors.length === 0) {
      const { userCode } = this.props.user;
      row.BloggerCode = userCode;
      //console.log(row);
      this.api_add_item(row);
    } else {
      let info = errors.join(",");
      message.error(info);
    }
  }

  /////////////////////////////////////////////////////////////
  render() {
    const { SubCategory, EventTitle } = this.state.item;
    return (
      <Card>
        <form onSubmit={this.handleSubmit}>
          <div className="col-lg">
            <div className="form-group">
              <label>
                <span className="text-danger ">*</span>項目分類
              </label>
              <select
                name="SubCategory"
                id="SubCategory"
                className="custom-select mb-3 text-success"
                style={{ backgroundColor: "LightCyan" }}
                defaultValue={SubCategory}
                key={SubCategory}
                onChange={this.handleChange}
              >
                <option value="other">請選擇</option>
                <option value="dissertation">論文</option>
                <option value="journals">期刊</option>
                <option value="book">專書</option>
                <option value="project">計畫案</option>
                <option value="awarded">獲獎</option>
                <option value="xhibition">展演</option>
                <option value="service">服務</option>
              </select>
              <div>
                <i
                  className="fa fa-question-circle"
                  style={{ color: "red" }}
                ></i>{" "}
                <a
                  href="https://wordvice.com.tw/apa-citation-generator"
                  target="_blank"
                  rel="noreferrer"
                >
                  APA格式產生器 <i className="fa fa-mouse-pointer"></i>
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg">
            <div className="form-group">
              <label>
                <span className="text-danger">*</span>項目內容
              </label>
              <TextArea
                name="EventTitle"
                id="EventTitle"
                rows={4}
                showCount
                maxLength={500}
                placeholder=""
                defaultValue={EventTitle}
                onChange={this.handleChange}
              />
            </div>
          </div>
          <div className="form-row">
            <div className="col-lg">
              <div className="form-group">
                <button
                  type="submit"
                  className="btn btn-warning btn-sm btn-block"
                >
                  <i className="fa fa-plus"></i>
                  <span style={{ marginLeft: "4px" }}>增加</span>
                </button>
              </div>
            </div>
          </div>
        </form>
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(AchievementDeedsTeacherAddModal);
